import type { RouteLocationNormalizedGeneric, Router } from "vue-router";

const UNTRACKED_ROUTE_PREFIXES = ["/login"];

/**
 * Tracks the current route, then every later navigation.
 * Start it once the initial navigation has resolved: `afterEach` does not fire for a navigation already done.
 */
export function startPageViewTracking(router: Router, trackPageView: (pageUrl: string) => Promise<unknown>) {
  async function trackRoute(route: RouteLocationNormalizedGeneric) {
    if (UNTRACKED_ROUTE_PREFIXES.some((prefix) => route.path.startsWith(prefix))) return;

    await trackPageView(route.fullPath);
  }

  router.afterEach(async (to) => {
    await trackRoute(to);
  });

  return trackRoute(router.currentRoute.value);
}
